import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { TranslateService } from '../../../../services/translate.service';
import { SegProfile } from '../../../../services/template-mappers/entities/risk-register-seg-group.model';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';

@Component({
    standalone: true,
    selector: 'app-seg-tasks-widget',
    imports: [],
    templateUrl: './seg-tasks-widget.component.html',
    styleUrl: './seg-tasks-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegTasksWidgetComponent implements OnInit {
    @Input() profiles: SegProfile[] | null = null;
    @Input() showGroupHeadings = true;

    readonly styles = SEG_STYLES;
    labels = { heading: '', noData: '' };

    constructor(private translateService: TranslateService) { }

    ngOnInit(): void {
        const t = (key: string) => this.translateService.getDynamicTranslation(key);
        this.labels = { heading: t('Tasks'), noData: t('No Data Available') };
    }

    public trackByIndex = trackByIndex;
}
